import React from 'react';
import styled, { stylesheet } from 'astroturf/react';
import routes from 'js/core_pre_webpack/routes';
import { ButtonLink } from 'js/design_system/link/ButtonLink';
import { Body } from 'js/design_system/Body';
import Divider from 'js/design_system/Divider';
import { Heading } from 'js/design_system/Heading';

const EmptyStateHeader = styled(Heading)`
  font-family: 'Roboto', Helvetica, Arial, sans-serif;
  font-size: 22px;
  font-weight: 400;
  line-height: 28px;
  color: $ds-black;
`;

const EmptyStateBody = styled(Body)`
  font-family: 'Roboto', Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  color: $ds-gray-dark;
`;

const styles = stylesheet`
  .ExploreButton {
    height: 54px;
    width: 226px;

    @media (max-width: 480px) {
      width: 100%;
    }
  }
`;

const ProfileEmptyState: React.FunctionComponent<{
  isOwner: boolean;
  username: string;
}> = ({ isOwner, username }) => {
  return (
    <>
      {!isOwner && (
        <div>
          <EmptyStateHeader>{username} hasn't posted yet</EmptyStateHeader>
          <EmptyStateBody>
            Once they do, their activity will show up here
          </EmptyStateBody>
        </div>
      )}
      <Divider.s16 />
      <ButtonLink href={routes.home_url()} className={styles.ExploreButton}>
        Explore Conversations ▸
      </ButtonLink>
    </>
  );
};

export default ProfileEmptyState;
